import { Box } from "@mui/material";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useMutation, useQuery } from "react-query";
import { Get, Post } from "utils/request";
import { useDispatch } from "react-redux";
import DefaultButton from "components/DefaultButton";
import JoditEditor from "jodit-react";
import JoditConfig from "utils/joditConfig";
import { Show } from "actions/SnackbarActions";


const config = new JoditConfig("jodit-upload-image").config();

const Formbody = () => {
    const dispatch = useDispatch();
    const [text, SetText] = useState("");

    const { isLoading } = useQuery("terms", async () => await Get("terms"), {
        onSuccess: (data) => {
            const { terms: { text = "" } = {} } = data || {};
            SetText(text ?? "");
        },
        refetchOnWindowFocus: false
    });

    const { mutate, isLoading: isMutating } = useMutation(async () => {
        const form = new FormData();
        form.append("text", text);

        return await Post("terms/update", form);
        }, {
        onSuccess: (data) => {
            const { message = "", severity = "error" } = data || {};
            dispatch(Show({
                show: true,
                message,
                severity: "success"
            }));
        },
        onError: (error) => {
            const { message = "", severity = "error" } = error || {};
            dispatch(Show({
                show: true,
                message,
                severity: "error"
            }));
        }
    });

    return (
        <Box
            component="form"
            onSubmit={e => {
                e.preventDefault();
                mutate()
            }}
        >
            <JoditEditor
                config={config}
                value={text}
                onChange={SetText}
            />
            <Box
                width="100%"
                display="flex"
                alignItems={"center"}
                justifyContent={"flex-end"}
                marginTop={2}
            >
                <DefaultButton
                    bg="confirm"
                    text="Salvar"
                    type="submit"
                />
            </Box>
        </Box>
    );
}

export default Formbody;